import React from 'react'
import styled from 'styled-components'
import { flex, colors } from '../styles'
import A from "./A"

const Footer = styled.footer`
  padding: 2rem 1rem;
  ${flex.center.wrap}
  color: white;
  background: ${colors.darkBackground};
  > * + * {
    margin-left: 0.5rem;
  }
  > * {
    margin-top: 1rem;
    ${flex.vertical.alignCenter}
    > * {
      margin-top: 0.25rem;
    }
  }
`

export default () => (
  <Footer>
    <A href="https://twitter.com/frontendcenter" target="_blank">🐦<span>@frontendcenter</span></A>
    <A href="mailto:glen@frontend.center">💌<span>glen@frontend.center</span></A>
    <A href="https://twitter.com/glenmaddern" target="_blank">💁<span>@glenmaddern</span></A>
  </Footer>
)



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/